module.exports = __webpack_public_path__ + "static/media/AboutUs-title-design.d50f67f3.svg";